import '@fontsource-variable/inter';
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource-variable/urbanist';
import {BrowserRouter} from '@nlabs/gothamjs/router';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {WorkspaceProvider} from './components/WorkspaceProvider/WorkspaceProvider.js';
import './styles.css';

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><WorkspaceProvider /></BrowserRouter></StrictMode>);
